/**
 * PushNotificationButton - Bottone per attivare/disattivare le notifiche push
 * Mostra stato, chiede permesso, gestisce subscribe/unsubscribe
 */
import { Bell, BellOff, BellRing } from "lucide-react";
import { usePushNotifications } from "../hooks/usePushNotifications";

export const PushNotificationButton = ({ token }) => {
  const { isSupported, permission, isSubscribed, isLoading, subscribe, unsubscribe } =
    usePushNotifications(token);

  if (!isSupported) return null;

  if (permission === "denied") {
    return (
      <div
        className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-medium"
        style={{ background: "rgba(239,68,68,0.08)", color: "#ef4444" }}
        title="Notifiche bloccate dal browser. Abilita nelle impostazioni."
        data-testid="push-notification-denied"
      >
        <BellOff className="h-4 w-4" />
        <span>Notifiche bloccate</span>
      </div>
    );
  }

  return (
    <button
      onClick={isSubscribed ? unsubscribe : subscribe}
      disabled={isLoading}
      data-testid="push-notification-btn"
      className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold transition-all active:scale-95"
      style={{
        background: isSubscribed
          ? "rgba(108,99,255,0.10)"
          : "rgba(108,99,255,0.06)",
        color: isSubscribed ? "#6C63FF" : "#9ca3af",
        border: `1px solid ${isSubscribed ? "rgba(108,99,255,0.2)" : "rgba(0,0,0,0.06)"}`,
      }}
      title={isSubscribed ? "Disattiva notifiche push" : "Attiva notifiche push"}
    >
      {isLoading ? (
        <div className="h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : isSubscribed ? (
        <BellRing className="h-4 w-4" />
      ) : (
        <Bell className="h-4 w-4" />
      )}
      <span>{isSubscribed ? "Notifiche on" : "Attiva notifiche"}</span>
    </button>
  );
};
